// extracted by mini-css-extract-plugin
module.exports = {"container":"_9fJbYZdHYAZP7OCXW5Jdc","groupsList":"_10afuRVWMdu5QsXFmuKS6y"};